// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { EntityEventType } from './entity-event-type';
import { EntityEventTypeEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class EntityEvent extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String(50) */
  applicationContext?: string;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** String(4) */
  crtnUserInit!: string;
  /** String */
  description?: string;
  /** Enum FK entityEventType */
  entityEventTypeId!: EntityEventTypeEnum;
  /** String(50) */
  entityId?: string;
  /** String(50) */
  entityTypeName?: string;
  /** String */
  resolutionDescription?: string;
  /** DateTimeOffset */
  resolutionTs?: Date;
  /** FK entityEventTypeId */
  entityEventType!: EntityEventType;
}

